import React from 'react';
import { ScheduleStep } from './ScheduleStep';
import { TableStep } from './TableStep';

// Step 2: Meet — combines the schedule + table sections.
// Wraps ScheduleStep + TableStep with a hairline divider between them.
// Ported from prototypes/campaign-creation-prototype.jsx MeetStep
// (lines 2302-2316).
export const MeetStep = ({ form, update, theme }) => {
  const c = theme.colors;
  return (
    <div style={{ padding: '24px 28px 20px' }}>
      <ScheduleStep form={form} update={update} theme={theme} />
      <div style={{
        height: 1,
        background: c.borderLight,
        opacity: 0.6,
        margin: '28px 0',
      }} />
      <TableStep form={form} update={update} theme={theme} />
    </div>
  );
};
